import { render, staticRenderFns } from "./ClubsSection.vue?vue&type=template&id=71b0814c&scoped=true&"
import script from "./ClubsSection.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ClubsSection.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ClubsSection.vue?vue&type=style&index=0&id=71b0814c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b0814c",
  null
  
)

export default component.exports